import { render, staticRenderFns } from "./PdvHeader.vue?vue&type=template&id=38a67f20&scoped=true"
import script from "./PdvHeader.vue?vue&type=script&lang=js"
export * from "./PdvHeader.vue?vue&type=script&lang=js"
import style0 from "./PdvHeader.vue?vue&type=style&index=0&id=38a67f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a67f20",
  null
  
)

export default component.exports